import { l } from '@manychat/manyui'

import * as actionTypes from 'apps/applications/constants/InstalledApplicationsReduxActionTypes'
import { UpdateStage } from 'common/actions/integrations/Applications/interfaces'
import { alert } from 'common/core'
import { getCurrentAccountID } from 'common/core/selectors/appSelectors'
import { getApplicationId } from 'common/settings/components/SettingsPanel/AppSection/installedApplications/selectors/updateInstalledApplicationSelectors'
import { ApplicationsApi } from 'shared/api/requests/applications'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchUsesList = createAsyncAction(
  'installedApplications/fetchUsesList',
  async (applicationId: number) => {
    const { data } = await ApplicationsApi.fetchUsesList({
      query: { app_id: applicationId },
    })

    return data.entities
  },
)

export const uninstallApplication = createAsyncAction(
  'installedApplications/uninstallApplication',
  async (applicationId: number, { getState }) => {
    const accountId = getCurrentAccountID(getState()).replace('fb', '')
    await ApplicationsApi.uninstall({
      body: { app_id: applicationId, account_id: Number(accountId) },
    })

    alert(l.translate('Application uninstalled successfully!'), 'success')
  },
)

export const fetchInstalledApps = createAsyncAction(
  'installedApplications/fetchInstalledApps',
  async () => {
    const { data } = await ApplicationsApi.fetchInstalledApps()
    return data.apps
  },
)

export const openUpdateModal = (applicationId: number) => ({
  type: actionTypes.APPLICATION_UPDATE_MODAL_OPEN,
  applicationId,
})

export const closeUpdateModal = () => ({
  type: actionTypes.APPLICATION_UPDATE_MODAL_CLOSE,
})

export const setStage = (stage: UpdateStage) => ({
  type: actionTypes.APPLICATION_VERSION_UPDATE_STAGE_SET,
  stage,
})

export const fetchChangeLog = createAsyncAction(
  'installedApplications/fetchChangeLog',
  async (_, { getState, rejectWithValue }) => {
    const applicationId = getApplicationId(getState())
    if (applicationId === null) {
      throw rejectWithValue()
    }

    const { data } = await ApplicationsApi.getChangelogs({
      query: { app_id: applicationId },
    })

    return data.changelog
  },
)

export const updateVersion = createAsyncAction(
  'installedApplications/updateVersion',
  async (_, { getState, rejectWithValue, dispatch }) => {
    const applicationId = getApplicationId(getState())
    if (applicationId === null) {
      throw rejectWithValue()
    }

    const { data } = await ApplicationsApi.updateVersion({
      body: { app_id: applicationId },
    })

    dispatch(closeUpdateModal())
    dispatch(fetchInstalledApps())
    alert(l.translate('Application updated successfully! Please check your App Setup'), 'success')

    return data
  },
)
